<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Custom Clearance Import Form</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-button-group size="sm">
              <b-button
                :disabled="CC_EDI == '0' ? true : false"
                @click="gotToPage('EDI')"
                :variant="CC_EDI == '0' ? '' : 'success'"
                >EDI Execution</b-button
              >
              <b-button
                :disabled="CC_EXEC == '0' ? true : false"
                @click="gotToPage('EXEC')"
                :variant="CC_EXEC == '0' ? '' : 'success'"
                >Execution</b-button
              >
              <b-button
                :disabled="CC_TRACK == '0' ? true : false"
                @click="gotToPage('TRACK')"
                :variant="CC_TRACK == '0' ? '' : 'success'"
                >Tracking</b-button
              >

              <!--<b-button disabled>BL</b-button> -->
            </b-button-group>
          </b-navbar-nav>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="this.ALLMODULE"
          :jobSeriesBanner="this.JOBSERIES"
          :bannerClientName="this.clientName"
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <!-- <md-layout md-gutter class="gutr">
              <md-layout md-flex="90"></md-layout>
              <md-layout md-flex="10">
                <md-button
                  v-if="ccModal.ccImportId"
                  @click="addStatus"
                  style="position: fixed;z-index:999;top:83%;"
                  class="md-fab"
                >
                  <md-icon>message</md-icon>
                </md-button>
              </md-layout>
            </md-layout> -->
            <div>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <label for="clientId">Importer Name</label>

                  <model-list-select
                    isDisabled
                    :list="clientList"
                    id="clientNamenew"
                    v-model="ccModal.importerClientId"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select Importer Name"
                  ></model-list-select>
                  <span class="error" v-if="!ccModal.importerClientId">{{
                    errorHouseBL.importerClientId
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <label for="clientId">Exporter Name</label>

                  <model-list-select
                    isDisabled
                    :list="clientList"
                    id="clientNamenew"
                    v-model="ccModal.exporterClientId"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select Exporter Name"
                  ></model-list-select>

                  <span class="error" v-if="!ccModal.exporterClientId">{{
                    errorHouseBL.exporterClientId
                  }}</span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr" v-if="openExpoInput == true">
                <md-layout md-flex="50"></md-layout>
                <md-layout md-flex="55">
                  <label for="clientId">Exporter Name</label>

                  <b-form-input
                    :formatter="capitalizeAll"
                    id="otherExpoName"
                    name="otherExpoName"
                    v-model="ccModal.otherExpoName"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <label for="PORlocationId">Place of Receipt</label>
                  <model-list-select
                    isDisabled
                    @input="getLocationList($event, 'All', 'IcdPOrtList')"
                    @searchchange="
                      getLocationList($event, 'All', 'IcdPOrtList')
                    "
                    :list="IcdPOrtListNew"
                    v-model="ccModal.PORlocationId"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Place of Receipt"
                  ></model-list-select>
                  <span class="error" v-if="!ccModal.PORlocationId">{{
                    errorHouseBL.PORlocationId
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <label for="LPlocationId">Load Port Name</label>
                  <model-list-select
                    @input="
                      getLocationList(
                        $event,
                        'Sea_Port,Air_Port',
                        'PortLoadList',
                      )
                    "
                    @searchchange="
                      getLocationList(
                        $event,
                        'Sea_Port,Air_Port',
                        'PortLoadList',
                      )
                    "
                    :list="PortLoadList"
                    v-model="ccModal.LPlocationId"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Load Port Name"
                    isDisabled
                  ></model-list-select>
                  <span class="error" v-if="!ccModal.LPlocationId">{{
                    errorHouseBL.LPlocationId
                  }}</span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <label for="PODLocationId">Port of Discharge</label>
                  <model-list-select
                    @input="
                      getLocationList(
                        $event,
                        'Sea_Port,Air_Port',
                        'getPortDischargeList',
                      )
                    "
                    @searchchange="
                      getLocationList(
                        $event,
                        'Sea_Port,Air_Port',
                        'getPortDischargeList',
                      )
                    "
                    :list="getPortDischargeList"
                    v-model="ccModal.PODLocationId"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Port of Discharge"
                    isDisabled
                  ></model-list-select>
                  <span class="error" v-if="!ccModal.PODLocationId">{{
                    errorHouseBL.PODLocationId
                  }}</span>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <label for="PODLocationId">Final Place of Delivery</label>
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceData')"
                    @searchchange="
                      getLocationList($event, 'All', 'finalAllPlaceData')
                    "
                    :list="finalAllPlaceData"
                    v-model="ccModal.fpodName"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Final Place Delivery"
                    isDisabled
                  ></model-list-select>

                  <!-- <label>Final Place of Delivery</label>
                  <b-form-input :formatter="capitalizeAll" id="fpodName" name="fpodName" v-model="ccModal.fpodName"></b-form-input>-->
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr">
                <md-layout md-flex="15">
                  <label>Pre-Alert Date</label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    id="preAlertDate"
                    name="preAlertDate"
                    v-model="ccModal.preAlertDate"
                  ></date-picker>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label>Vessel ETA</label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    id="vesselEta"
                    name="vesselEta"
                    v-model="ccModal.vesselEta"
                  ></date-picker>
                </md-layout>

                <md-layout md-flex="10"></md-layout>
                <md-layout md-flex="20">
                  <label> Free Days at India Port </label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="freeDaysIndia"
                    name="freeDaysIndia"
                    v-model="ccModal.freeDaysIndia"
                  ></b-form-input>
                </md-layout>

                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="25">
                  <label for="pdaDetail">Destination Handling Fees By</label>
                  <model-list-select
                    :list="pdaDetailsName"
                    v-model="ccModal.pdaDetail"
                    option-value="pdaDetailsVal"
                    option-text="pdaDetailsText"
                    placeholder="Select "
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <label>MBL No.</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="mblNo"
                    name="mblNo"
                    v-model="ccModal.mblNo"
                  ></b-form-input>
                  <span class="error" v-if="!ccModal.mblNo">{{
                    errorHouseBL.mblNo
                  }}</span>
                  <!-- <span class="error" v-else-if="mblRegexError!=''">{{mblRegexError}}</span>  @keyup="mblRegexfun"-->
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>MBL Date</label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    id="mblDate"
                    name="mblDate"
                    v-model="ccModal.mblDate"
                  ></date-picker>
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="30">
                  <label for="stuffingType">De-Stuffing Type</label>
                  <model-list-select
                    :list="stuffingTypeName"
                    v-model="ccModal.stuffingType"
                    option-value="stuffingTypeVal"
                    option-text="stuffingTypeText"
                    placeholder="Select Type"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <div class="mt-3">
                <h5>
                  <b-badge>HBL Details</b-badge>
                </h5>
              </div>
              <b-card clstyle="background:whiteSmoke">
                <md-layout md-gutter class="gutr">
                  <md-layout md-flex="40">
                    <label>HBL No.</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="mblNo"
                      name="mblNo"
                      v-model="ccModal.hblNo"
                    ></b-form-input>
                    <span class="error" v-if="!ccModal.hblNo">{{
                      errorHouseBL.hblNo
                    }}</span>
                    <!-- <span @keyup="hblRegexfun" class="error" v-else-if="blRegexError!=''">{{blRegexError}}</span> -->
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>

                  <md-layout md-flex="15">
                    <label>HBL Date</label>
                    <date-picker
                      :format="selectDateFormat"
                      lang="en"
                      id="hblDate"
                      name="hblDate"
                      v-model="ccModal.hblDate"
                    ></date-picker>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <label for="BlType">B/L Type</label>
                    <model-list-select
                      :list="
                        ccModal.containerInfo == 'fcl'
                          ? blTypeList
                          : blTypeListLcl
                      "
                      v-model="ccModal.BlType"
                      option-value="blTypeVal"
                      option-text="blTypeTxt"
                      placeholder="Select B/L Type"
                    ></model-list-select>
                  </md-layout>
                </md-layout>

                <div v-for="(item, index) in ccModal.multiHBL" :key="index">
                  <md-layout md-gutter class="gutr">
                    <md-layout md-flex="40">
                      <label for="stuffingType">HBL No.</label>
                      <b-input
                        style="height: 37px"
                        name="securityAmount"
                        id="securityAmount"
                        v-model="item.multiHBLNo"
                      ></b-input>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="15">
                      <label>HBL Date</label>

                      <date-picker
                        :format="selectDateFormat"
                        lang="en"
                        id="receivedDo"
                        name="receivedDo"
                        v-model="item.multiHBLDate"
                      ></date-picker>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="15">
                      <label for="BlType">B/L Type</label>
                      <model-list-select
                        :list="
                          ccModal.containerInfo == 'fcl'
                            ? blTypeList
                            : blTypeListLcl
                        "
                        v-model="item.BlType"
                        option-value="blTypeVal"
                        option-text="blTypeTxt"
                        placeholder="Select B/L Type"
                      ></model-list-select>
                    </md-layout>

                    <b-button
                      size="sm"
                      class="ml-2"
                      variant="outline-dark"
                      style="margin-top: 38px"
                      @click="removeHBL(index)"
                    >
                      <md-icon>remove</md-icon>
                    </b-button>
                  </md-layout>
                </div>
                <md-layout md-gutter class="gutr">
                  <md-layout md-flex="15">
                    <b-button
                      variant="outline-dark"
                      size="sm"
                      @click="addAdditionalHBL"
                      class="md-fab md-fab"
                      >Add More HBL</b-button
                    >
                  </md-layout>
                </md-layout>
              </b-card>

              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <label for="shippingId"
                    >Shipping Line Name:<span class="error">*</span></label
                  >
                  <model-list-select
                    :list="shippingList"
                    v-model="ccModal.shippingId"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                  ></model-list-select>
                  <span
                    class="error"
                    v-if="!ccModal.shippingId || ccModal.shippingId == 0"
                    >{{ errorCustomValidation.shippingId }}</span
                  >
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <label>Gateway IGM No.:<span class="error">*</span></label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="igmNo"
                    name="igmNo"
                    v-model="ccModal.gateIgmNo"
                  ></b-form-input>
                  <span class="error" v-if="!ccModal.gateIgmNo">{{
                    errorCustomValidation.gateIgmNo
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label>Gateway IGM Date:<span class="error">*</span></label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    id="receivingDate"
                    name="receivingDate"
                    v-model="ccModal.gatewayIgmDate"
                  ></date-picker>
                  <span class="error" v-if="!ccModal.gatewayIgmDate">{{
                    errorCustomValidation.gatewayIgmDate
                  }}</span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="25">
                  <label>Vessel / Voy:<span class="error">*</span></label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="vesselName"
                    name="vesselName"
                    v-model="ccModal.vesselName"
                  ></b-form-input>
                  <span class="error" v-if="!ccModal.vesselName">{{
                    errorCustomValidation.vesselName
                  }}</span>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label
                    >Vessel Arrival Date:<span class="error">*</span></label
                  >
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    id="vesselFinalDate"
                    name="vesselFinalDate"
                    v-model="ccModal.vesselFinalDate"
                  ></date-picker>
                  <span class="error" v-if="!ccModal.vesselFinalDate">{{
                    errorCustomValidation.vesselFinalDate
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout
                  md-flex="25"
                  v-if="ccModal.PODLocationId != ccModal.fpodName"
                >
                  <label>Local IGM No.:<span class="error">*</span></label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="igmNo"
                    name="igmNo"
                    v-model="ccModal.igmNo"
                  ></b-form-input>
                  <span class="error" v-if="!ccModal.igmNo">{{
                    errorCustomValidation.igmNo
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout
                  md-flex="15"
                  v-if="ccModal.PODLocationId != ccModal.fpodName"
                >
                  <label>Local Igm Date:<span class="error">*</span></label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    id="vesselFinalDate"
                    name="vesselFinalDate"
                    v-model="ccModal.igmDate"
                  ></date-picker>
                  <span class="error" v-if="!ccModal.igmDate">{{
                    errorCustomValidation.igmDate
                  }}</span>
                </md-layout>
              </md-layout>

              <!-- <md-layout md-gutter v-if="ccModal.ccImportId!=''" class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="15">
              <h4 style="margin:0px" class="showMoreData" >Add More Container</h4>
            </md-layout>
              </md-layout>-->
              <md-layout md-gutter class="gutr mt-3">
                <md-layout md-flex="25">
                  <!-- Other Services -->
                  <h5>
                    <b-badge>Check with Importer For</b-badge>
                  </h5>
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
                <md-layout
                  md-flex="100"
                  v-for="(segmentNameArray, index) in showSegmentArray"
                  :key="index"
                >
                  <md-layout md-flex="15">
                    <md-checkbox
                      v-model="ccModal.checkWithImporter[index]"
                      class="md-primary"
                      :md-value="segmentNameArray.value"
                      :name="'checkWithImporter' + (index + 1)"
                      :id="'checkWithImporter' + (index + 1)"
                      >{{ segmentNameArray.show }}</md-checkbox
                    >
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>

                  <md-layout
                    md-flex="80"
                    class="gutr"
                    v-if="ccModal.checkWithImporter[index] == true"
                  >
                    <b-form-input
                      :formatter="capitalizeAll"
                      v-model="ccModal.rebateAll[index]"
                      >{{ segmentNameArray.show }}</b-form-input
                    >
                  </md-layout>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr">
                <md-layout md-flex="80">
                  <label for="autoCommodity">Commodity</label>
                  <!-- <model-list-select
                    @searchchange="getCommodityList($event, 'getCommodityData')"
                    :list="getCommodityData"
                    v-model="ccModal.commodityId"
                    option-value="commodityId"
                    option-text="itemDescription"
                    placeholder="Select Commodity"
                  ></model-list-select> -->
                  <model-list-select
                    @searchchange="getCommodityList($event, 'getCommodityData')"
                    :list="getCommodityData"
                    v-model="ccModal.commodityId"
                    option-value="commodityId"
                    option-text="itemHSNCode"
                    placeholder="Select Commodity"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <b-button
                    variant="primary"
                    @click="openCommodityModal()"
                    id="addButtonLoader"
                    size="sm"
                    style="margin-top: 40px"
                    >Add</b-button
                  >
                </md-layout>
                <!-- <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="45">
              <md-layout md-flex="100">
                <label for="commodityType">Commodity Type</label>

                <b-form-input :formatter="capitalizeAll"
                  id="commodityType"
                  name="commodityType"
                  disabled
                  v-model="ccModal.commodityType"
                ></b-form-input>
              </md-layout>
                </md-layout>-->
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <label for="commodityType">Commodity Type</label>
                  <model-list-select
                    :list="commodityTypeName"
                    v-model="ccModal.commodityType"
                    option-value="commodityTypeVal"
                    option-text="commodityTypeText"
                    placeholder="Select Commodity Type"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="90">
              <md-layout md-flex="100">
                <label for="itemDescription">Item Description</label>

                <b-form-textarea :formatter="capitalizeAll"
                  id="itemDescription"
                  name="itemDescription"
                  disabled
                  v-model="ccModal.itemDescription"
                ></b-form-textarea>
              </md-layout>
            </md-layout>
              </md-layout>-->
              <md-layout
                md-gutter
                class="gutr"
                v-if="ccModal.commodityType == 'Hazardous'"
              >
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>IMDG Class</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="IMDGClass"
                      name="IMDGClass"
                      v-model="ccModal.IMDGClass"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>UN Number</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="UNNumber"
                      name="UNNumber"
                      v-model="ccModal.UNNumber"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Packing Code</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="packingCode"
                      name="packingCode"
                      v-model="ccModal.packingCode"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout
                md-gutter
                class="gutr"
                v-if="ccModal.commodityType == 'Reefer'"
              >
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Temperature Req(Degree Celsius)</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="temperatureRequired"
                      name="temperatureRequired"
                      v-model="ccModal.temperatureRequired"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout
                md-gutter
                class="gutr"
                v-if="ccModal.commodityType == 'Others'"
              >
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>Specific Detail if any..!</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="otherComodity"
                      name="otherComodity"
                      v-model="ccModal.otherComodity"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label for="itemDescription">Remark</label>

                    <b-form-textarea
                      :formatter="capitalizeAll"
                      id="remark"
                      name="remark"
                      v-model="ccModal.remark"
                      style="height: 140px"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
              <div class="mt-3">
                <h5>
                  <b-button
                    size="sm"
                    class="pull-right"
                    @click="showDocModal"
                    variant="dark"
                    >Upload Documents</b-button
                  >
                </h5>
              </div>
              <!-- <b-card class="mt-2" style="background:whiteSmoke">
                  <md-layout md-gutter class="gutr">
                    

                    <md-layout md-flex="30">
                      <label for="trackingDoc">Document Name</label>
                      <model-list-select
                        option-value="trackingDocVal"
                        option-text="trackingDocText"
                        :list="trackingDocList"
                        placeholder="Select Document "
                        v-model="docModal.trackingDoc"
                      ></model-list-select>
                      <span class="error" v-if="!docModal.trackingDoc">{{errorDocModal.trackingDoc}}</span>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30">
                      <md-input-container>
                        <label>Upload Document</label>

                        <md-file
                          name="trackDocUpload"
                          id="trackDocUpload"
                          v-model="docModal.trackDocUpload"
                          @selected="onFileChangetracking"
                          multiple
                        ></md-file>
                      </md-input-container>
                      <span
                        class="error"
                        v-if="!docModal.trackDocUpload"
                      >{{errorDocModal.trackDocUpload}}</span>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="15">
                      <label>Receiving Date</label>
                      <date-picker
                        lang="en"
                        id="receivingDate"
                        name="receivingDate"
                        v-model="docModal.receivingDate"
                      ></date-picker>
                      <span
                        class="error"
                        v-if="!docModal.receivingDate"
                      >{{errorDocModal.receivingDate}}</span>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="10">
                      <b-button
                        style="margin-top:38px"
                        size="sm"
                        variant="info"
                        id="addButtonLoaderUp"
                        @click="addCCImport('')"
                      >Upload</b-button>
                      <md-spinner md-indeterminate id="loaderUp" style="display:none"></md-spinner>
                    </md-layout>
                  </md-layout>
                  <md-layout
                    md-gutter
                    v-if="trackingUploadView.length >0 && ccModal.ccImportId==''"
                  >
                    <md-layout md-flex="40"></md-layout>
                    <md-layout md-flex="15" v-for="(item,index) in trackingUploadView" :key="index">
                     
                      <a
                        :href="`${this.docURL}/dummy/`+item"
                        target="_blank"
                        download
                      >View Document - {{index+1}}</a>
                    </md-layout>
                  </md-layout>

               
                  <div class="mt-3" v-if="docTableData.length>0">
                   

                   
                    <div class="box-body">
                      <table id="ffBookingTentative" class="table table-striped">
                        <thead>
                          <tr>
                            <th>Sr No.</th>

                            <th>Document</th>
                            <th>Receiving Date</th>

                            <th>View Doc</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item,index) in docTableData" :key="index">
                            <td>{{index+1}}</td>

                            <td>{{item.trackingDoc }}</td>
                            <td>{{item.receivingDate | moment }}</td>

                            <td>
                              <md-button
                                class="md-icon-button md-raised md-dense"
                                @click="viewDoc(item.trackDocUpload)"
                              >
                                <md-icon>visibility</md-icon>
                              </md-button>
                            </td>
                            <td>
                              <md-button
                                class="md-icon-button md-raised md-dense"
                                @click="DeleteDoc(item.ccdocId,item.trackDocUpload)"
                              >
                                <md-icon>delete_sweep</md-icon>
                              </md-button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                 
                  </div>
                </b-card> -->

              <!-- v-if="noteUpload" -->
              <div class="gutr">
                <b-button
                  class="mt-3"
                  variant="primary"
                  id="addButtonLoaderPro"
                  @click="addCCImport('0')"
                  >Save & Submit</b-button
                >
              </div>
              <div>
                <b-button
                  class="mt-1"
                  variant="primary"
                  id="addButtonLoaderPro"
                  @click="addCCImport('csfds')"
                  >Save & Proceed to Edi Execution</b-button
                >
                <!-- <md-spinner class="pull-right" md-indeterminate id="loaderPro" style="display:none"></md-spinner> -->
              </div>
            </div>
          </b-card-text>

          <b-col lg="12">
            <span
              class="error pull-right"
              v-if="ccModal.CCImportDetailsCreated"
            >
              <b> {{ ccModal.CCImportDetailsCreated }}</b>
            </span>
          </b-col>

          <b-col lg="12">
            <span
              class="error pull-right"
              v-if="ccModal.CCImportDetailsUpdated"
            >
              <b> {{ ccModal.CCImportDetailsUpdated }}</b>
            </span>
          </b-col>

          <!-- <b-col lg="12"> {{ ccModal }} </b-col> -->
        </b-card>
      </b-card-text>
    </b-card>
    <div v-if="ALLMODULE">
      <b-modal
        size="xl"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div>
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button
          class="mt-3"
          variant="outline-danger"
          block
          @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>

      <!-- Commodity Modal Added By Priyanshu Singh Start -->
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        size="xl"
        ref="Commodity-modal"
        hide-footer
        title=""
      >
        <div class="d-block text-center">
          <h3>Add Commodity</h3>
        </div>
        <b-row>
          <b-col md="6" class="my-1">
            <b-row>
              <b-col md="4" class="text-right">
                <label>Item Name <span class="error">*</span></label>
              </b-col>
              <b-col md="8" class="my-1">
                <b-form-input
                  size="sm"
                  :formatter="capitalizeAll"
                  id="itemName"
                  name="itemName"
                  v-model="commodityModal.itemName"
                ></b-form-input>
                <span class="error" v-if="!commodityModal.itemName">{{
                  errorList.itemName
                }}</span>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row>
              <b-col md="4" class="text-right">
                <label>HSN Code <span class="error"></span></label>
              </b-col>
              <b-col md="8" class="my-1">
                <b-form-input
                  size="sm"
                  :formatter="capitalizeAll"
                  id="hsnCode"
                  name="hsnCode"
                  v-model="commodityModal.hsnCode"
                ></b-form-input>
                <span class="error" v-if="!commodityModal.hsnCode">{{
                  errorList.hsnCode
                }}</span>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="5" class="my-1"></b-col>
          <b-col md="2" class="my-1">
            <b-button
              variant="primary"
              @click="addCommodity"
              id="addButtonLoader"
              size="sm"
              >Save</b-button
            >
            <b-button
              variant="outline-danger"
              size="sm"
              @click="hideCommodityModal"
              >Close</b-button
            >
            <md-spinner
              md-indeterminate
              id="loader"
              style="display: none"
            ></md-spinner>
          </b-col>
          <b-col md="5" class="my-1"></b-col>
        </b-row>
      </b-modal>
      <!-- Commodity Modal Added By Priyanshu Singh Start -->
    </div>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="alertAddSeaImp"
      @close="onCloseEdiTeam"
    ></md-dialog-alert>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose7"
      ref="addPop7"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="message"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalGetCommodity,
  GlobalGetCommodity2,
  GlobalContainerValid,
} from "../../helper/collection";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import DocForm from "../../component/allModuleForm/docLibrary.vue";

export default {
  beforeMount() {
    if (globalPermissionStatus("Custom Clearance")) {
      this.$store.dispatch("setCurrentRoute", "/CCImport/CCImportEntry");
      this.getServicesData();
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    // CommodityAll: {
    //   handler: function(newVal, oldVal) {
    //     this.CommodityCallback(newVal);
    //   },
    //   deep: true
    // },
    docModal: {
      handler: function (newVal, oldVal) {
        if (this.docModal.trackingDoc != "") {
          let array = this.docTableData.filter((x) => {
            return x.trackingDoc == this.docModal.trackingDoc;
          });

          if (array.length > 0) {
            this.alert.content =
              this.docModal.trackingDoc + " Document Already Exist";
            this.$refs["message"].open();
            this.docModal.trackingDoc = "";
          }
        }
      },
      deep: true,
    },
    ccModal: {
      handler: function (newVal, oldVal) {
        if (this.ccModal.exporterClientId != "") {
          let dummyExporter = this.getCLientData.filter((x) => {
            return x.clientId == this.ccModal.exporterClientId;
          });
          if (dummyExporter.length > 0) {
            if (dummyExporter[0].clientName == "Others") {
              this.openExpoInput = true;
            } else {
              this.openExpoInput = false;
            }
          }
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      // Added vy Priyanshu Singh Start
      commodityModal: {
        commodityNewId: "",
        itemName: "",
        hsnCode: "",
      },
      CommodityError: [
        "Please Enter ItemName",
        // "Please Enter HSNCode",
      ],
      errorList: {
        itemName: "",
        // hsnCode: "",
      },
      // Added vy Priyanshu Singh End
      selectDateFormat,
      allSame: "0",
      docURL: URL_BASE_DOC,
      arrivalDateIndex: "",
      railOutDateIndex: "",
      freeDaysIndex: "",
      MODULEID: "",
      stuffingTypeName: [
        {
          stuffingTypeVal: "factoryStuffing",
          stuffingTypeText: "Factory",
        },
        {
          stuffingTypeVal: "warehouseStuffing",
          stuffingTypeText: "Warehouse",
        },
      ],
      commodityTypeName: [
        {
          commodityTypeVal: "Hazardous",
          commodityTypeText: "DANGEROUS CARGO (HAZ)",
        },
        {
          commodityTypeVal: "Reefer",
          commodityTypeText: "TEMPERATUR CONTROLLED ( REEFER)",
        },
        {
          commodityTypeVal: "Others",
          commodityTypeText: "GENERAL (OTHERS)",
        },
      ],
      commodityTypeName_bak: [
        {
          commodityTypeVal: "Hazardous",
          commodityTypeText: "Hazardous",
        },
        {
          commodityTypeVal: "Non_Hazardous",
          commodityTypeText: "Non Hazardous",
        },
        {
          commodityTypeVal: "Reefer",
          commodityTypeText: "Reefer",
        },
        {
          commodityTypeVal: "Others",
          commodityTypeText: "Others",
        },
      ],
      trackingDocList: [
        {
          trackingDocVal: "CoO",
          trackingDocText: "CoO",
        },
        {
          trackingDocVal: "Invoice",
          trackingDocText: "Invoice",
        },
        {
          trackingDocVal: "PackingList",
          trackingDocText: "Packing List",
        },
        {
          trackingDocVal: "B/L",
          trackingDocText: "B/L",
        },
        {
          trackingDocVal: "Insurance",
          trackingDocText: "Insurance",
        },
        {
          trackingDocVal: "Others",
          trackingDocText: "Others",
        },
      ],
      pdaDetailsName: [
        {
          pdaDetailsVal: "Pridel",
          pdaDetailsText: "Pridel",
        },
        {
          pdaDetailsVal: "Consignee",
          pdaDetailsText: "Consignee",
        },
        // {
        //   pdaDetailsVal: "Liner",
        //   pdaDetailsText: "Liner"
        // }
      ],
      multiContainer: [],
      containerNo: [],
      docTableData: [],
      errorDo: ["Select Document", "Upload Document", "Select Receiving Date"],
      errorDocModal: {
        trackingDoc: "",
        trackDocUpload: "",
        receivingDate: "",
      },
      editorOption: {
        modules: {},
      },
      editorContent: "",
      isLoading: false,

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      showAlgo: false,
      algoConNo: "",
      containerNoRegexError: [],
      CommodityAll: {},
      autoClientName: {},
      clientName: "",
      firstRadio: "",
      ccModal: {
        allModuleId: "",
        stuffingType: "",
        igmDate: "",
        otherExpoName: "",
        multiHBL: [],
        ccImportId: "",
        ccType: "Import",
        pdaDetail: "",
        exporterClientId: "",
        PORlocationId: "",
        PODLocationId: "",
        importerClientId: "",
        LPlocationId: "",
        freeDaysIndia: "",
        shippingId: "",
        igmNo: "",
        noOfContainers: "",
        multiContainer: [],
        rebateAll: ["", "", "", "", ""],
        ContainerNo: "",
        ContainerType: "",
        checkWithImporter: [],
        commodityId: "",
        commodityType: "",
        itemDescription: "",
        IMDGClass: "",
        UNNumber: "",
        packingCode: "",
        temperatureRequired: "",
        otherComodity: "",
        mblNo: "",
        mblDate: "",
        hblNo: "",
        hbltype: "",
        hblDate: "",
        BlType: "",
        gateIgmNo: "",
        gatewayIgmDate: "",
        fpodName: "",
        vesselName: "",
        vesselEta: "",
        preAlertDate: "",
        remark: "",
        statusFinal: "",
        vesselFinalDate: "",

        CCImportDetailsCreated: "",
        CCImportDetailsUpdated: "",
      },
      blTypeList: [
        {
          blTypeVal: "HouseBL",
          blTypeTxt: "House B/L",
        },

        {
          blTypeVal: "MasterBL",
          blTypeTxt: "Master B/L",
        },
      ],
      blTypeListLcl: [
        {
          blTypeVal: "HouseBL",
          blTypeTxt: "House B/L",
        },

        {
          blTypeVal: "Co-Loader",
          blTypeTxt: "Co-Loader",
        },
      ],
      openExpoInput: false,
      blRegexError: "",
      errorMultiContainer: [],

      // CUstom Validation Variable Declaration Start 23/06/2023
      errorCustomValidation: {
        shippingId: "",
        gateIgmNo: "",
        gatewayIgmDate: "",
        vesselName: "",
        vesselFinalDate: "",
        igmNo: "",
        igmDate: "",
      },

      arrayErrorCustomValidation: [
        {
          shippingId: "Select Shipping Line Name",
          gateIgmNo: "Enter Gateway IGM No.",
          gatewayIgmDate: "Enter Gateway IGM Date",
          vesselName: "Enter Vessel / Voy",
          vesselFinalDate: "Enter Vessel Arrival Date",
          igmNo: "Enter Local IGM No.",
          igmDate: "Enter Local Igm Date",
        },
      ],
      // CUstom Validation Variable Declaration End 23/06/2023
      errorHouseBL: {
        exporterClientId: "",
        PORlocationId: "",
        PODLocationId: "",
        importerClientId: "",
        LPlocationId: "",
        shippingId: "",
        mblNo: "",
        hblNo: "",
        hbltype: "",
      },

      CC_EDI: "",
      CC_EXEC: "",
      CC_TRACK: "",
      multipleHouseBLData: "",
      noOfContainersError: "",
      arrayErrorHouseBL: [
        "Select Exporter Name",
        "Select Place of Receipt",
        "Select Place of Discharge",
        "Select Importer Name",
        "Select Load Port",
        "Select Shipping ",
        "Enter MBL No ",
        "Select HBL No ",
      ],
      docModal: {
        ccImportId: "",
        ccdocId: "",
        trackingDoc: "",
        trackDocUpload: "",
        receivingDate: "",
      },
      ffExoprtDetail: {
        ffairImportId: "",
        checkWithImporter: [],
        transportType: "AirImport",
        containerInfo: "",
        airlineId: "",
        flightDate: "",
        alertReceivedDate: "",
        firstBLNumber: "",
        firstBLDate: "",
        firstBlType: "MasterBL",
        firstBLRadio: "",
        firstOcFreghtTerms: "",
        firstBLupload: "",
        preCarriageBy: "",
        PORlocationId: "",
        PODLocationId: "",
        etaArrivalPort: "",
        vesselVoyage: "",
        LPlocationId: "",
        finalPlaceLocationId: "",
        etaDischargePort: "",
        marksNos: "",
        descriptionGood: "",
        commodity: "",
        noOfPkg: "",
        volumeWeightCargo: "",
        finalChargeableWeight: "",
        grossWeightCargo: "",
        ffExportremarks: "",
      },
      getDayFromDate: "",
      ALLMODULE: "",
      JOBSERIES: "",
      deleteId: "",
      uploadDelete: "",

      shippingIdError: "",
      totalContainer: "",
      noOfContainerError: "",
      containerTypeIdError: "",

      fobReceiptName: "",
      fobLoadPortName: "",
      commodityArray: [],
      getPortData: ["Agra"],

      error: {
        clientNameError: "",
        toPortError: "",
        fromPortError: "",
        transhipmentNameError: "",
        addOneTranError: "",
      },
      getCLientData: ["gfdg"],
      showSegmentArray: [],

      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New",
      },

      hblRegexError: "",
      mblRegexError: "",

      checkWithImporterSelectVal: false,

      getShippingLineData: ["zim"],
      getCommodityData: ["zim"],
      getContainerTypeData: ["zim"],
      getlocationListData: ["agra"],
      getAlllocationListData: ["agra"],
      IcdPOrtList: [],
      getPortDischargeList: [],
      PortLoadList: [],
      finalAllPlaceData: [],
      validate: true,
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    VueTrix,
    quillEditor,
    DocForm,
    BannerComponent,
  },
  computed: {
    // noteUpload() {
    //   if (this.docTableData.length > 0) {
    //     let array = this.docTableData.filter(x => {
    //       return (
    //         x.trackingDoc == "Invoice" ||
    //         x.trackingDoc == "B/L" ||
    //         x.trackingDoc == "Insurance"
    //       );
    //     });
    //     return array.length == 3 ? true : false;
    //   } else {
    //     return false;
    //   }
    // },
    trackingUploadView() {
      return this.docModal.trackDocUpload != ""
        ? this.docModal.trackDocUpload.split(",")
        : [];
    },

    MultiContainerList() {
      return this.multiContainer;
    },
    clientList() {
      return this.getCLientData;
    },
    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    shippingList() {
      return this.getShippingLineData;
    },
    locationList() {
      return this.getlocationListData;
    },
    IcdPOrtListNew() {
      return this.IcdPOrtList;
    },

    PortDischargeList() {
      return this.getPortDischargeList;
    },
    allLocationList() {
      return this.getAlllocationListData;
    },
    PortList() {
      return this.getPortData;
    },
  },
  methods: {
    showDocModal() {
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    gotToPage(ID) {
      if (ID == "EDI") {
        this.$router.push({
          path: "/CCImport/newEdiExecution",
        });
      } else if (ID == "EXEC") {
        this.$router.push({
          path: "/CCImport/ExecutionImport",
        });
      } else if (ID == "TRACK") {
        this.$router.push({
          path: "/CCImport/ccImportTracking",
        });
      } else {
        console.log("no");
      }
    },
    addSameDate(index) {
      this.arrivalDateIndex = this.multiContainer[index].arrivalDate;
      this.railOutDateIndex = this.multiContainer[index].railOutDate;
      this.freeDaysIndex = this.multiContainer[index].freeDays;
    },

    addSameDateRadio() {
      if (this.allSame == "1") {
        this.multiContainer.map((x) => {
          x.arrivalDate = "";
          x.railOutDate = "";
          x.freeDays = "";
        });
      } else {
        console.log("56565");
        this.multiContainer.map((x) => {
          x.arrivalDate = this.arrivalDateIndex;
          x.railOutDate = this.railOutDateIndex;
          x.freeDays = this.freeDaysIndex;
        });
      }
    },

    getCommodityList(event, vmodelArray) {
      let vehicle_drive = {
        value: event,
      };

      let self = this;

      if (event != "") {
        GlobalGetCommodity2(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
              console.log(self[vmodelArray]);
            }
          }
        });
      }
    },
    // showExpInput() {
    //   if (this.ccModal.exporterClientId != "") {
    //     let dummyExporter = this.getCLientData.filter(x => {
    //       return x.clientId == this.ccModal.exporterClientId;
    //     });
    //     if (dummyExporter.length > 0) {
    //       if (dummyExporter[0].clientName == "Others") {
    //         this.openExpoInput = true;
    //       } else {
    //         this.openExpoInput = false;
    //       }
    //     }
    //   }
    // },
    addAdditionalHBL() {
      let doSection1 = {
        multiHBLDate: "",
        multiHBLNo: "",
        BlType: "",
        notifyList: [
          {
            inputValue: "",
            text: "",
          },
        ],
        surrenderDate: "",
        originalBlRecDate: "",
        secondBLRadio: "",
        secondOcFreghtTerms: "",
        secondBLupload: "",
        inputValue: "",
      };

      this.ccModal.multiHBL.push(doSection1);
    },
    removeHBL(index) {
      this.ccModal.multiHBL.splice(index, 1);
      //  this.errorMultiContainer.splice(index, 1);
    },
    addStatus() {
      let data = {
        jobType: "2",
        typeOf: "1",
        allMessageId: this.$sessionsStorage.get("editCcImportId"),
        statusMain: this.ccModal.statusFinal,
        login: "normal",
      };

      this.$sessionsStorage.set("MessageStatus", JSON.stringify(data));

      this.$router.push({
        path: "/UpdateStatus/internalAssignStatus",
      });
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    containerNoRegexfun(index) {
      let abc = this.multiContainer[index].ContainerNo.toUpperCase();

      this.multiContainer[index].ContainerNo = abc;
      console.log(this.multiContainer[index].ContainerNo);
      this.showAlgo = true;
      this.getConAlgoList(index);
      this.algoConNo = this.validContainerNo;
      console.log(this.validContainerNo);
      var containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");

      if (containerformat.test(this.multiContainer[index].ContainerNo)) {
        this.containerNoRegexError[index] = "";
        if (this.multiContainer[index].ContainerNo != this.algoConNo) {
          this.containerNoRegexError[index] =
            "Note:System Generated Container No. is : " + this.algoConNo;
        } else {
          this.containerNoRegexError[index] = "";
        }
      } else {
        this.containerNoRegexError[index] = "Enter Valid Format";
      }
      this.$forceUpdate();
    },
    getConAlgoList(index) {
      //let self = this;

      if (this.multiContainer[index].ContainerNo != "") {
        this.validContainerNo = GlobalContainerValid(
          this.multiContainer[index].ContainerNo,
        );
      }
    },

    DeleteDoc(item, upload) {
      this.deleteId = item;
      this.uploadDelete = upload;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop7"].open();
    },

    onClose7(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "cc_multipledocentry",
          tableId: "ccdocId",
          isActive: "isActiveDoc",
          tableVal: this.deleteId,
          uploadDelete: this.uploadDelete,
          link: `/ccImportEntryDoc`,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Custom/deletePermanentWithFile.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            // this.JqueryFun();
            this.getData();
            this.deleteId = "";
          })
          .catch((error) => {});
      }
    },

    viewDoc(id) {
      // window.open("http://13.229.240.246/ccImportEntryDoc/" + id);

      window.open(`${this.docURL}/CC_Import_Uploads/` + id);
    },

    onCloseEdiTeam(type) {
      if (type != "cancel") {
        this.$router.push({
          path: "/CCImport/newEdiExecution",
        });
      }
    },

    removeNotify(index) {
      this.multiContainer.splice(index, 1);
      this.errorMultiContainer.splice(index, 1);

      this.ccModal.noOfContainers = this.ccModal.noOfContainers - 1;
    },
    addContainer() {
      let obj = {
        ContainerNo: "",
        ContainerType: "",
        railOutDate: "",
        arrivalDate: "",
        freeDays: "",
      };
      let obj1 = {
        ContainerNo1: "",
        ContainerType1: "",
        railOutDate: "",
        arrivalDate: "",
        freeDays: "",
      };
      this.multiContainer.push(obj);
      this.errorMultiContainer.push(obj1);
      this.ccModal.noOfContainers = +this.ccModal.noOfContainers + 1;
    },
    getNoofCon() {
      if (this.ccModal.noOfContainers != "" && this.ccModal.ccImportId == "") {
        let array = [];
        for (let i = 0; i < this.ccModal.noOfContainers; i++) {
          let obj = {
            ContainerNo: "",
            ContainerType: "",
            railOutDate: "",
            arrivalDate: "",
            freeDays: "",
          };

          let obj1 = {
            ContainerNo1: "",
            ContainerType1: "",
            railOutDate1: "",
            arrivalDate1: "",
            freeDays1: "",
          };

          array.push(obj);
          this.errorMultiContainer.push(obj1);
        }
        return (this.multiContainer = array);
      } else if (
        this.ccModal.noOfContainers == "" ||
        this.ccModal.noOfContainers == 0 ||
        this.ccModal.noOfContainers == "0"
      ) {
        this.multiContainer = [];
      }
    },
    // CommodityCallback(item) {
    //   this.ccModal.commodityId = item.commodityId;
    //   this.ccModal.commodityType = item.commodityType;
    //   this.ccModal.itemDescription = item.itemDescription;
    // },

    onFileChangetracking() {
      let files = event.target.files || event.dataTransfer.files;

      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        formData.append(
          "moduleId",
          this.$sessionsStorage.get("editCcImportId"),
        );

        formData.append(
          "staticFileName",
          "CC_ImportEntryPg_" + this.docModal.trackingDoc,
        );

        formData.append("upload_dir_folderName", "CC_Import_Uploads");
      }

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAll.php`, formData, config)
        .then((result) => {
          this.docModal.trackDocUpload = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },

    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    checkWithImporterSelect(value, index) {
      if (value == "RebateCertificate") {
        if (this.rebateInput == false) {
          this.rebateInput = true;
        } else {
          this.rebateInput = false;
        }
      }
      if (value == "AdvanceLicense") {
        if (this.advanceLicenseInput == false) {
          this.advanceLicenseInput = true;
        } else {
          this.advanceLicenseInput = false;
        }
      }
      if (value == "DutyBond") {
        if (this.dutyBondInput == false) {
          this.dutyBondInput = true;
        } else {
          this.dutyBondInput = false;
        }
      }
      if (value == "EBCG_License") {
        if (this.ebcgInput == false) {
          this.ebcgInput = true;
        } else {
          this.ebcgInput = false;
        }
      }
      if (value == "DutyFree") {
        if (this.dutyFreeInput == false) {
          this.dutyFreeInput = true;
        } else {
          this.dutyFreeInput = false;
        }
      }
    },
    validateFFExport(id) {
      var blformat = new RegExp("^[0-9]{11}$");
      var containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");

      let validate_new = true;
      var error = "";
      if (id == "") {
        Object.keys(this.errorDocModal).map((x, index) => {
          if (this.docModal[x] == "") {
            this.errorDocModal[x] = this.errorDo[index];

            validate_new = false;
          } else {
            this.errorDocModal[x] = "";
          }
        });
      }

      Object.keys(this.errorHouseBL).map((x, index) => {
        if (this.ccModal[x] == "") {
          error = "dsfdsf1";
          this.errorHouseBL[x] = this.arrayErrorHouseBL[index];
          validate_new = false;
        } else {
          this.errorHouseBL[x] = "";
        }
      });

      const __array = this.multiContainer;

      __array.map((x, index) => {
        Object.keys(x).map((y) => {
          if (this.multiContainer[index][y] == "") {
            if (y == "ContainerType") {
              error = "dsfdsf2";
              this.errorMultiContainer[index]["ContainerType1"] =
                "Enter Container Type";
            } else {
              error = "dsfdsf7";
              this.errorMultiContainer[index]["ContainerNo1"] =
                "Enter Container Number";
            }

            validate_new = false;
          } else {
            // if (
            //   containerformat.test(this.multiContainer[index][y]) &&
            //   y == "ContainerNo"
            // ) {
            //   this.errorMultiContainer[index]["ContainerNo1"] = "";
            // } else if (y == "ContainerNo") {
            //   error = "fsdfds3";
            //   this.errorMultiContainer[index]["ContainerNo1"] =
            //     "Enter Valid Format";
            //   validate_new = false;
            // }
            //     this.errorMultiContainer[index]["ContainerType1"] = "";
          }
        });
      });

      // if (blformat.test(this.ccModal.mblNo)) {
      //   this.mblRegexError = "";
      // } else {

      //   this.mblRegexError = "Enter Valid Format";
      //   validate_new = false;
      //   error = "dsfdsf4";
      // }

      // if (blformat.test(this.ccModal.hblNo)) {
      //   this.hblRegexError = "";
      // } else {

      //   this.hblRegexError = "Enter Valid Format";
      //   validate_new = false;
      //   error = "dsfdsf5";
      // }

      // if (this.ccModal.noOfContainers == "") {
      //   error = "dsfdsf5rwwer";

      //   this.noOfContainersError = "Enter No. of Containers";
      //   validate_new = false;
      // }

      if (error != "") {
        window.scroll(0, 50);
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    // mblRegexfun() {
    //   var blformat = new RegExp("^[0-9]{11}$");
    //   let arrayLen = [];

    //   if (blformat.test(this.ccModal.mblNo)) {
    //     this.mblRegexError = "";
    //   } else {
    //     this.mblRegexError = "Enter Valid Format";
    //   }
    // },
    hblRegexfun() {
      var blformat = new RegExp("^[0-9]{11}$");
      let arrayLen = [];

      if (blformat.test(this.ccModal.hblNo)) {
        this.hblRegexError = "";
      } else {
        this.hblRegexError = "Enter Valid Format";
      }
    },
    // CUstom Validation Variable Declaration Start 23/06/2023
    validateFFImportCustomVali() {
      let validate_new = true;
      Object.keys(this.errorCustomValidation).map((x, index) => {
        if (
          this.ccModal[x] == "" ||
          this.ccModal[x] == 0 ||
          this.ccModal[x] == undefined ||
          this.ccModal[x] == null ||
          this.ccModal[x] == "undefined" ||
          this.ccModal[x] == "null"
        ) {
          {
            console.log("this.errorCustomValidation[x] x=>", x);
            console.log(
              "this.errorCustomValidation[x]=>",
              this.errorCustomValidation[x],
            );
            console.log(
              "this.arrayErrorCustomValidation[0][x]=>",
              this.arrayErrorCustomValidation[0][x],
            );
            this.errorCustomValidation[x] =
              this.arrayErrorCustomValidation[0][x];
            if (
              (x == "igmNo" &&
                this.ccModal.PODLocationId != this.ccModal.fpodName) ||
              (x == "igmDate" &&
                this.ccModal.PODLocationId != this.ccModal.fpodName) ||
              x == "shippingId" ||
              x == "gateIgmNo" ||
              x == "gatewayIgmDate" ||
              x == "vesselName" ||
              x == "vesselFinalDate"
            ) {
              validate_new = false;
            }
          }
          // if ((x == "igmNo" && (this.ccModal.PODLocationId != this.ccModal.fpodName)) || (x == "igmDate" && (this.ccModal.PODLocationId != this.ccModal.fpodName))) {
          //   validate_new = false;
          // }
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    // CUstom Validation Variable Declaration End 23/06/2023
    addCCImport(id) {
      // $("#clientId").focus();/
      this.ccModal.allModuleId = this.MODULEID;
      let newVal = [];
      let rebateAll = "";
      this.showSegmentArray.map((x, index) => {
        console.log("Happy SIngh=>", x);
        rebateAll +=
          this.ccModal.rebateAll[index] == "" || this.ccModal.rebateAll == null
            ? " ,"
            : this.ccModal.rebateAll[index] + ",";
        if (this.ccModal.checkWithImporter[index] == true) {
          newVal.push(x.value);
        }
      });

      this.ccModal.rebateAll = rebateAll;

      //   this.validateFFExport(id);
      this.ccModal["checkWithImporterArry"] = newVal;
      this.ccModal["multiContainer"] = this.multiContainer;
      let new_data = {
        docModal: this.docModal,
        ccModal: this.ccModal,
        onlyExecMain: "",
      };
      let firstHBLARR = {
        multiHBLDate: this.ccModal.hblDate,
        multiHBLNo: this.ccModal.hblNo,
        BlType: this.ccModal.BlType,
        // notifyList : notifyList,
        // surrenderDate : surrenderDate,
        // originalBlRecDate : originalBlRecDate,
        // secondBLRadio : secondBLRadio,
        // secondOcFreghtTerms : secondOcFreghtTerms,
        // secondBLupload : secondBLupload,
        // inputValue : inputValue,
      };
      // console.log("this.ccModal.multiHBL=>",this.ccModal.multiHBL)
      // alert(this.ccModal.multiHBL.length)
      if (
        this.ccModal.multiHBL != undefined &&
        this.ccModal.multiHBL != null &&
        this.ccModal.multiHBL != "" &&
        this.ccModal.multiHBL.length > 0
      ) {
        this.ccModal.multiHBL.unshift(firstHBLARR);

        this.ccModal.multiHBL.forEach((element) => {
          element.multiHBLNo =
            element.multiHBLNo != undefined ? element.multiHBLNo : "";
          element.BlType = element.BlType != undefined ? element.BlType : "";
          element.BlType = element.BlType != undefined ? element.BlType : "";
          element.multiHBLDate =
            element.multiHBLDate != undefined ? element.multiHBLDate : "";
          element.notifyList =
            element.notifyList != undefined
              ? element.notifyList
              : [
                  {
                    inputValue: "",
                    text: "",
                  },
                ];
          element.surrenderDate =
            element.surrenderDate != undefined ? element.surrenderDate : "";
          element.originalBlRecDate =
            element.originalBlRecDate != undefined
              ? element.originalBlRecDate
              : "";
          element.secondBLRadio =
            element.secondBLRadio != undefined ? element.secondBLRadio : "";
          element.secondOcFreghtTerms =
            element.secondOcFreghtTerms != undefined
              ? element.secondOcFreghtTerms
              : "";
          element.secondBLupload =
            element.secondBLupload != undefined ? element.secondBLupload : "";
          element.inputValue =
            element.inputValue != undefined ? element.inputValue : "";
          this.ccModal.multiHBL.push(element);
        });
      }
      this.ccModal.hbl_Arr = JSON.stringify(this.ccModal.hbl_Arr);
      this.ccModal.commonmultiHBL = JSON.stringify([
        ...new Set(this.ccModal.multiHBL),
      ]);
      // console.log("Priyanshu SIngh=>", new_data);
      // return false;
      if (id == "") {
        new_data["onlyExecMain"] = "";
      } else {
        new_data["onlyExecMain"] = "csfds";
      }
      let sameConNo = [];

      // CUstom Validation Variable Declaration Start 23/06/2023
      this.validateFFImportCustomVali(); // Custom Validation 23/06/2023
      console.log("Priyanshu SIngh=>", this.validate);
      console.log(
        "Priyanshu SIngh errorCustomValidation =>",
        this.errorCustomValidation,
      );
      console.log(
        "Priyanshu SIngh arrayErrorCustomValidation =>",
        this.arrayErrorCustomValidation,
      );
      // return false;
      // CUstom Validation Variable Declaration End 23/06/2023

      if (this.validate != false) {
        this.isLoading = true;
        if (id == "") {
          $("#addButtonLoaderUp").css("display", "none");
          $("#loaderUp").css("display", "block");
        } else {
          $("#addButtonLoaderPro").css("display", "none");
          $("#loaderPro").css("display", "block");
        }

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Custom/addCCImpEntry.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (status == 200 && data) {
              //              this.$sessionsStorage.set("editCcImportId", data.ccImportId);

              this.ccModal.ccImportId = data.ccImportId;
              if (id == "") {
                $("#loaderUp").css("display", "none");
                $("#addButtonLoaderUp").css("display", "block");
              } else {
                $("#loaderPro").css("display", "none");
                $("#addButtonLoaderPro").css("display", "block");
              }

              if (id != "") {
                this.$sessionsStorage.set("editCcType", "Import");
                this.alert.content = "Data Updated Succesfully";
                if (id == "0") {
                  this.$refs["message"].open();
                } else {
                  this.$refs["alertAddSeaImp"].open();
                }
              } else {
                Object.keys(this.docModal).map((x) => {
                  this.docModal[x] = "";
                });
              }
              this.isLoading = false;
              if (id == "0") {
                this.getData();
              }
            }
          })
          .catch((error) => {});
      }
    },

    getData() {
      this.doLoading();
      let array = [];
      let vehicle_drive = {
        itemCode: "itemCode",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Custom/getDataCCImpEntry1.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            let containerNo = [];
            let containerType = [];
            let railOutDate = [];
            let arrivalDate = [];
            let freeDays = [];

            let multiHBLDate = [];
            let multiHBLNo = [];

            if (data.clientdetail.length > 0) {
              this.getCLientData = data.clientdetail;
            }

            if (data.slineDetails.length > 0) {
              this.getShippingLineData = data.slineDetails;
            }
            console.log("data.CommodityData1SQL=>", data.CommodityData1SQL);
            console.log("data.CommodityDataSQL=>", data.CommodityDataSQL);
            console.log("data.CommodityData=>", data.CommodityData);
            if (data.CommodityData_new.length > 0) {
              // this.getCommodityData = data.CommodityData;
              this.getCommodityData = data.CommodityData_new;
            }
            if (data.containerMaster.length > 0) {
              this.getContainerTypeData = data.containerMaster;
            }
            let otherNewContainerFLow = "0";
            console.log("data.ccEntryImportData=>", data.ccEntryImportData);
            if (data.ccEntryImportData.length > 0) {
              this.MODULEID = data.ccEntryImportData[0].allModuleId;
              this.ALLMODULE = data.ccEntryImportData[0].allModuleId;
              this.JOBSERIES = data.ccEntryImportData[0].ccImportSeries;
              otherNewContainerFLow =
                data.ccEntryImportData[0].otherNewContainerFLow;
              this.clientName = "";
              data.clientdetail.forEach((user) => {
                if (
                  user.clientId == data.ccEntryImportData[0].importerClientId
                ) {
                  this.clientName = user.clientName;
                }
              });
              Object.keys(data.ccEntryImportData[0]).map((x) => {
                if (x == "ContainerNo") {
                  if (
                    data.ccEntryImportData[0][x] != "" &&
                    data.ccEntryImportData[0][x] != null
                  ) {
                    containerNo = data.ccEntryImportData[0][x].split(",") || [];
                  } else {
                    containerNo = [];
                  }
                } else if (x == "checkWithImporter") {
                  if (
                    data.ccEntryImportData[0][x] != "" &&
                    data.ccEntryImportData[0][x] != null
                  ) {
                    array = data.ccEntryImportData[0][x].split(",") || "";
                  } else {
                    array = [];
                  }
                } else if (x == "ContainerType") {
                  if (
                    data.ccEntryImportData[0][x] != "" &&
                    data.ccEntryImportData[0][x] != null
                  ) {
                    containerType =
                      data.ccEntryImportData[0][x].split(",") || [];
                  } else {
                    containerType = [];
                  }
                  console.log(data);
                } else if (x == "railOutDate") {
                  if (
                    data.ccEntryImportData[0][x] != null &&
                    data.ccEntryImportData[0][x] != ""
                  ) {
                    railOutDate = data.ccEntryImportData[0][x].split(",") || [];
                  } else {
                    railOutDate = [];
                  }
                } else if (x == "arrivalDate") {
                  if (
                    data.ccEntryImportData[0][x] != null &&
                    data.ccEntryImportData[0][x] != ""
                  ) {
                    arrivalDate = data.ccEntryImportData[0][x].split(",") || [];
                  } else {
                    arrivalDate = [];
                  }
                } else if (x == "freeDays") {
                  if (
                    data.ccEntryImportData[0][x] != null &&
                    data.ccEntryImportData[0][x] != ""
                  ) {
                    freeDays = data.ccEntryImportData[0][x].split(",") || [];
                  } else {
                    freeDays = [];
                  }
                } else if (x == "multiHBLDate") {
                  if (data.ccEntryImportData[0][x] != null) {
                    multiHBLDate =
                      data.ccEntryImportData[0][x].split(",") || [];
                  } else {
                    multiHBLDate = [];
                  }
                } else if (x == "multiHBLNo") {
                  if (data.ccEntryImportData[0][x] != null) {
                    multiHBLNo = data.ccEntryImportData[0][x].split(",") || [];
                  } else {
                    multiHBLNo = [];
                  }
                } else if (x == "rebateAll") {
                  if (data.ccEntryImportData[0][x] != null) {
                    this.ccModal[x] = data.ccEntryImportData[0][x].split(",");
                  } else {
                    this.ccModal[x] = [];
                  }
                } else {
                  this.ccModal[x] = data.ccEntryImportData[0][x] || "";
                }
              });
              console.log("data.multiHBLNo=>", multiHBLNo);
              this.ccModal["multiHBL"] = [];
              // alert(otherNewContainerFLow);
              if (otherNewContainerFLow == 0) {
                if (multiHBLNo.length > 0) {
                  multiHBLNo.map((p, index) => {
                    let obj2 = {
                      multiHBLNo: p,
                      multiHBLDate: multiHBLDate[index],
                    };

                    this.ccModal.multiHBL.push(obj2);
                  });
                }
              } else if (otherNewContainerFLow == 1) {
                this.ccModal.multiHBL = [];
                // alert(data.ccEntryImportData[0]["newArr"].length);
                if (
                  data.ccEntryImportData[0]["newArr"] != null &&
                  data.ccEntryImportData[0]["newArr"] != undefined &&
                  data.ccEntryImportData[0]["newArr"] != "" &&
                  data.ccEntryImportData[0]["newArr"].length > 0
                ) {
                  if (data.ccEntryImportData[0]["newArr"].length > 0) {
                    this.ccModal.hblNo =
                      data.ccEntryImportData[0]["newArr"][0]["multiHBLNo"];
                    this.ccModal.hblDate =
                      data.ccEntryImportData[0]["newArr"][0]["multiHBLDate"];
                    this.ccModal.BlType =
                      data.ccEntryImportData[0]["newArr"][0]["BlType"];
                  }
                }

                this.ccModal.multiHBL = data.ccEntryImportData[0].hbl_Arr;
              }

              this.ccModal["checkWithImporter"] = [];
              this.showSegmentArray.map((x, index) => {
                let i = array.indexOf(x.value);

                i >= 0
                  ? (this.ccModal.checkWithImporter[index] = true)
                  : (this.ccModal.checkWithImporter[index] = false);
              });

              this.multiContainer = [];
              this.errorMultiContainer = [];

              if (containerType.length > 0) {
                containerType.map((x, index) => {
                  let obj = {
                    ContainerType: x,
                    ContainerNo: containerNo[index],
                    railOutDate: railOutDate[index],
                    arrivalDate: arrivalDate[index],
                    freeDays: freeDays[index],
                  };
                  let obj1 = {
                    ContainerNo1: "",
                    ContainerType1: "",
                    railOutDate1: "",
                    arrivalDate1: "",
                    freeDays1: "",
                  };

                  this.multiContainer.push(obj);
                  this.errorMultiContainer.push(obj1);
                });
              }

              this.CommodityAll = this.getCommodityData.filter((x) => {
                return x.commodityId == data.ccEntryImportData[0].commodityId;
              })[0];
              if (data.ccEntryImportData[0]["portType"] == "Icd") {
                this.IcdPOrtList = data.LocationDetailsFinal;
              } else {
                this.IcdPOrtList = data.LocationDetailsSEAPORT;
              }
            } else {
              this.IcdPOrtList = data.LocationDetailsSEAPORT;
            }

            this.getPortDischargeList = data.LocationDetailsSEAPORT;
            this.PortLoadList = data.LocationDetailsSEAPORT;
            this.finalAllPlaceData = data.LocationDetailsFinal;

            if (data.ccEntryImpDocdata.length) {
              this.docTableData = data.ccEntryImpDocdata;
            }
            // if (data.LocationDetails.length > 0) {
            //   this.getAlllocationListData = data.LocationDetails;
            //   this.getPortDischargeList = data.LocationDetails.filter(x => {
            //     // return x.locationType == "Sea_Port" || x.locationType == "Icd";
            //     return x.locationType == "Air_Port";
            //   });
            //   this.IcdPOrtList = data.LocationDetails.filter(x => {
            //     return x.locationType == "Sea_Port" || x.locationType == "Icd";
            //   });
            //   this.getlocationListData = this.getAlllocationListData.filter(
            //     x => {
            //       return x.locationType != "Client_Factory";
            //     }
            //   );
            // }
            this.CC_EDI = data.CC_EDI;
            this.CC_EXEC = data.CC_EXEC;
            this.CC_TRACK = data.CC_TRACK;

            this.doLoadingClose();

            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    addNew() {
      this.$router.push({
        path: "/client/addClient",
      });
    },

    previousFFView() {
      // window.history.go(-1);
      this.$router.push({
        path: "/CCImport/CCImportDetails",
      });
    },

    getServicesData() {
      this.showSegmentArray = [
        {
          value: "RebateCertificate",
          show: "Rebate Certificate",
          flex: "20",
        },
        {
          value: "AdvanceLicense",
          show: "Advance License",
          flex: "20",
        },
        {
          value: "DutyBond",
          show: "Duty Bond",
          flex: "15",
        },

        {
          value: "EPCG_License",
          show: "EPCG License",
          flex: "15",
        },
        {
          value: "DutyFree",
          show: "Duty Free",
          flex: "15",
        },
        {
          value: "Others",
          show: "Others",
          flex: "15",
        },
      ];
    },
    // Added By Priyanshu Singh Start
    openCommodityModal() {
      this.isLoading = false;
      this.$refs["Commodity-modal"].show();
    },
    hideCommodityModal() {
      this.$refs["Commodity-modal"].hide();
      this.isLoading = false;
    },
    validateCommodity() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (this.commodityModal[x] == "") {
          this.errorList[x] = this.CommodityError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addCommodity() {
      this.validateCommodity();
      if (this.validate != false) {
        this.commodityModal.type = "Normal";
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addCommodity_VP.php`,
          data: JSON.stringify(this.commodityModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              // alert(data.find);

              if (
                data.commodityNewId != "" &&
                data.commodityNewId != undefined
              ) {
                if (data.find == 1) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                  this.commodityModal.commodityNewId = "";
                  this.commodityModal.itemName = "";
                  this.commodityModal.hsnCode = "";
                  if (data.CommodityData.length > 0) {
                    this.getCommodityData = data.CommodityData;
                  } else {
                    this.getCommodityData = [];
                  }
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.hideCommodityModal();
              console.log("MyData=>", data);
              console.log("Mystatus=>", status);
              this.$refs["addPop"].open();
            }
          })
          .catch((error) => {});
      }
    },
    // Added By Priyanshu Singh End
  },
};
</script>
<style>
.saveButton {
  text-align: center;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// newCCImportEntry.vue?0dab31fa